import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const mapOrderInvoice = ({
  id,
  orderId,
  expirationDate,
  paymentConfirmed,
  paymentDate,
  fundPaymentDate,
  fundExpirationDate,
  fechaVencimiento,
  verificationStatus,
  statusReason,
  status,
  discount,
  discountReason,
  baseRate,
  amountRetention,
  destinationId,
  oldStatus,
  defaultDate,
}) => {
  return {
    id,
    orderId,
    expirationDate,
    paymentConfirmed,
    paymentDate,
    fundPaymentDate,
    fundExpirationDate,
    fechaVencimiento,
    verificationStatus,
    statusReason,
    status,
    discount,
    discountReason,
    baseRate,
    tasaBase: baseRate,
    destinationId,
    oldStatus,
    defaultDate,
    ...(typeof amountRetention !== 'undefined' && { amountRetention }),
  };
};

export const updateInvoiceService = async ({ orderInvoiceId, invoice }) => {
  const body = mapOrderInvoice(invoice);
  try {
    const { data } = await axios.put(`/api/orderfactura/${orderInvoiceId}`, {
      data: { ...body, notCalculateSurplus: null },
    });
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

export default updateInvoiceService;
